export default __webpack_public_path__ + "static/media/2020-plan-1.d117548a.jpeg";